import apiCore from '../../utils/api-core';

export function getFailedMessagesReport(start,end,companyId=null){
	let urlString = `/api/v1/failed-messages-report/export/${start}/${end}`

	if(companyId)
		urlString += `?companyId=${companyId}`;

	return apiCore.get(urlString);
}


export function getMessagesReport(start,end,companyId=null) {
	let urlString = `/api/v1/daily-report/export/${start}/${end}`

	if(companyId)
		urlString += `?companyId=${companyId}`;

	return apiCore.get(urlString);
}

export function getLoginsReport(start,end) {
	return apiCore.get(`/api/v1/logins-report/export/${start}/${end}`);
}

export function getContactsReport(start, end, companies, active) {
	let queryString = '';
	let companyString = encodeURIComponent(companies)

	if (companies && active) {
		queryString = `?companies=${companyString}&active=true`
	} else if (companies) {
		queryString = `?companies=${companyString}`
	} else if (active) {
		queryString = `?active=true`
	}

	return apiCore.get(`/api/v1/companies/contacts/${start}/${end}` + queryString);
}